module.exports = __webpack_public_path__ + "static/media/tti_promotion_title@3x.451ece0b.png";